<template>
    <div>
        <div class="popup_st02">
            <div class="popup_wrap">
                <div class="title">
                    <span class="ict_btn blue">{{ alarmInfo.val5 }}</span>
                    <span class="t01">{{ alarmInfo.val3 }}</span>
                </div>

                <div class="pop_table03">
                    <table>
                        <caption>건설리스트</caption>
                        <colgroup>
                            <col style="width: 30%;"/>
                        </colgroup>
                        <tbody>
                        <tr>
                            <th>발주기관</th>
                            <td><span>{{ alarmInfo.val13 }}</span></td>
                        </tr>
                        <tr v-if="alarmInfo.val14 !== ''">
                            <th>관리단</th>
                            <td><span>{{ alarmInfo.val14 }}</span></td>
                        </tr>
                        <tr>
                            <th>시공사</th>
                            <td><span>{{ alarmInfo.val15 }}</span></td>
                        </tr>
                        <tr>
                            <th>착공일</th>
                            <td><span>{{ formatDate(alarmInfo.val6) }}</span></td>
                        </tr>
                        <tr>
                            <th>준공예정일</th>
                            <td><span>{{ formatDate(alarmInfo.val7) }}</span></td>
                        </tr>
                        <tr>
                            <th>도급액</th>
                            <td><span>{{ alarmInfo.val8 }}억원</span></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pop_btn_more"><a href="javascript: void(0);" class="building-alarm-desc">상세보기</a></div>
                <div class="pop_bt_close2" style="margin-top: 2px;"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>
            </div>
        </div>
    </div>
</template>

<script>
import { $_TYPE } from '@/confs/common.const';
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";

export default {
    props: {
        wrapClass: {
            type: String,
            default: 'popup_wrap'
        }
    },
    data() {
        return {
            alarmInfo: {},
        };
    },
    computed: {
    },
    updated() {
        this.$emit('loaded-building-alarm', this.$el.innerHTML);
    },
    methods: {
        setAlarmInfo(alarmInfo) {
            this.alarmInfo = Object.assign({}, alarmInfo);
        },
        formatDate(val) {
            if(typeof val !== $_TYPE.UNDEF && val.length == 8) {
                return gripUtil.formatDate(val, 'yyyy-MM-dd');
            }
            return '';
        },
    },
}
</script>
